import { render, staticRenderFns } from "./MultiPlanCategoryRoi.vue?vue&type=template&id=56b2d004&scoped=true"
import script from "./MultiPlanCategoryRoi.vue?vue&type=script&lang=js"
export * from "./MultiPlanCategoryRoi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2d004",
  null
  
)

export default component.exports